import './TaskBarAppIcon.css';

export function TaskBarAppIcon({ icon, name, onClick, isClosing }) {
    return (
        <div className={`app-icon ${isClosing ? 'app-icon_closing' : ''}`} onClick={onClick}>
            <img src={icon} alt={name} className="app-icon_image" />
        </div>
    );
}
